import { QueryClient } from '@tanstack/react-query';

export const createQueryClient = () => {
	return new QueryClient({
		defaultOptions: {
			queries: {
				keepPreviousData: true,
				retry: false,
				staleTime: 10 * 60 * 1000,
			},
		},
	});
};
